<template>
	<v-card class="mb-5" max-width="500">
		<v-card-title>
			Aggiungi Carta
		</v-card-title>
		<v-card-text>
			<div class="stripe-card-container">
				<div class="py-3">
			<div id="card-element"></div>
				</div>

			<div v-if="cardErrors" class="card-errors">
				{{ cardErrors }}
			</div>

				<div id="paymentElement"></div>
			</div>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				@click="savePaymentDetails"
				:loading="isLoading"
				color="primary"
				class="text-transform-none"
			>
				Aggiungi
			</v-btn>
		</v-card-actions>
	</v-card>

</template>

<script>
import CrudClient from "@/services/CrudClient";

export default {
	name: "StripeAddPaymentMethod",
	data() {
		return {
			stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
			cardElement: null,
			isLoading: false,
			cardErrors: null,
			paymentElement: null
		}
	},
	created() {
		this.StripePaymentsService = new CrudClient("StripePayments");
	},
	mounted() {
		this.loadStripe();
	},

	methods: {
		loadStripe() {
			if (window.Stripe) {
				this.stripe = window.Stripe(this.stripePublishableKey);
				this.isStripeLoaded = true;
				// If component is already mounted, set up card element
				if (this.$el) {
					this.setupCardElement();
				}
				return;
			}

			// Load Stripe.js script
			const script = document.createElement("script");
			script.src = "https://js.stripe.com/v3/";
			script.onload = () => {
				this.stripe = window.Stripe(this.stripePublishableKey);
				this.isStripeLoaded = true;
				// If component is already mounted, set up card element
				if (this.$el) {
					this.setupCardElement();
				}
			};
			document.head.appendChild(script);
		},

		setupCardElement() {
			// Make sure both the stripe and DOM element are ready
			if (!this.stripe || !document.getElementById("card-element")) {
				console.error("Stripe or card element container not ready");
				return;
			}

			// Create Elements instance
			this.elements = this.stripe.elements();

			// Create and mount the Card Element
			this.cardElement = this.elements.create("card", {
				hidePostalCode: true,
				style: {
					base: {
						fontSize: "16px",
						color: "#32325d",
						fontFamily: "\"Helvetica Neue\", Helvetica, sans-serif",
						"::placeholder": {
							color: "#aab7c4"
						}
					},
					invalid: {
						color: "#fa755a",
						iconColor: "#fa755a"
					}
				}
			});

			// Mount the Card Element to the DOM
			this.cardElement.mount("#card-element");

			// Add event listener for change events
			this.cardElement.on("change", (event) => {
				if (event.error) {
					this.cardErrors = event.error.message;
				} else {
					this.cardErrors = null;
				}
			});
		},

		async savePaymentDetails() {
			this.isLoading = true;
			this.cardErrors = null;
			this.$log.debug("savePaymentDetails");

			try {
				// Create a payment method using the card element
				const {
					paymentMethod,
					error
				} = await this.stripe.createPaymentMethod({
					type: "card",
					card: this.cardElement
				});

				this.$log.debug({ paymentMethod });
				this.$log.debug({ error });

				if (error) {
					this.cardErrors = error.message;
					return;
				}

				// Send the payment method to your server
				const response = await this.StripePaymentsService.Post(
					null,
					paymentMethod,
					"create-setup-intent",
					true
				);

				this.$log.debug({ response });

				// Handle the setupIntent response
				const {
					clientSecret,
					requiresAction
				} = response;

				// If 3DS verification is needed
				if (requiresAction) {
					this.$log.debug("requiresAction");

					// Use Stripe.js to handle 3DS authentication flow
					const {
						setupIntent,
						error: setupError
					} = await this.stripe.confirmCardSetup(
						clientSecret,
						{
							payment_method: {
								card: this.cardElement,
							}
						});

					this.$log.debug({
						setupIntent,
						error: setupError
					});

					if (setupError) {
						this.cardErrors = setupError.message;
						return;
					}

					if (setupIntent.status === "succeeded") {
						// Card verified successfully
						this.$emit("card-verified", setupIntent.payment_method);
						// Refresh saved cards list
						this.userCards = await this.StripePaymentsService.Get(
							null,
							"SavedPaymentMethods"
						);
					}
				} else {
					// Card was verified without 3DS
					this.$emit("card-verified", response.paymentMethodId);
					// Refresh saved cards list
					this.userCards = await this.StripePaymentsService.Get(
						null,
						"SavedPaymentMethods"
					);
				}
			} catch (err) {
				this.cardErrors = err.message;
			} finally {
				this.isLoading = false;
			}
		},
	}
};
</script>

<style scoped lang="scss">
.stripe-card-container {
	max-width: 500px;
	margin: 0 auto;
	padding: 20px;

	h2 {
		margin-bottom: 20px;
		text-align: center;
	}

	.card-element-container {
		margin-bottom: 20px;
	}

	.card-errors {
		color: #ff0000;
		margin-bottom: 15px;
	}

}
</style>
